"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Collapse, _React$Component);

  function Collapse() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      height: _this.props.forceInitialAnimation || !_this.props.isOpen ? 0 : null,
      isAnimating: false,
      isMounted: false,
      isOpen: _this.props.isOpen
    });

    _defineProperty(_assertThisInitialized(_this), "previousHeight", 0);

    _defineProperty(_assertThisInitialized(_this), "raf", null);

    _defineProperty(_assertThisInitialized(_this), "timer", null);

    _defineProperty(_assertThisInitialized(_this), "getHeight", function () {
      var child = _this.wrapper && _this.wrapper.firstElementChild;
      return child ? Math.max(child.offsetHeight - 1, 0) : 0; // - 1px to avoid jump after transition
    });

    _defineProperty(_assertThisInitialized(_this), "transition", function () {
      var newHeight = _this.props.isOpen ? _this.getHeight() : 0;
      clearTimeout(_this.timer);
      cancelAnimationFrame(_this.raf);
      _this.isAnimating = true;

      _this.setState({
        height: _this.previousHeight,
        isAnimating: true,
        shouldAnimate: false
      }, function () {
        _this.previousHeight = newHeight;
        _this.raf = requestAnimationFrame(function () {
          _this.raf = requestAnimationFrame(function () {
            _this.setState({
              height: newHeight
            }, function () {
              _this.timer = setTimeout(function () {
                _this.setState({
                  height: _this.props.isOpen ? null : 0,
                  isAnimating: false
                }, function () {
                  _this.isAnimating = false;
                });
              }, _this.props.duration);
            });
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTransitionEnd", function () {
      _this.previousHeight = _this.getHeight();
    });

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        isMounted: true
      }, function () {
        if (_this2.props.forceInitialAnimation) {
          _this2.transition();
        } else {
          _this2.previousHeight = _this2.props.isOpen ? _this2.getHeight() : 0;

          _this2.setState({
            isAnimating: false
          });
        }
      });
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      return this.props.isOpen ? this.getHeight() : 0;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, prevHeight) {
      if (this.isAnimating && !this.state.shouldAnimate) {
        return;
      }

      var newHeight = this.getHeight();
      var childrenDidChange = newHeight !== prevHeight;
      this.props.onMeasure(newHeight);

      if (this.state.shouldAnimate || childrenDidChange && this.props.animateChildren) {
        this.transition();
      } else if (childrenDidChange) {
        this.previousHeight = this.getHeight();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.raf);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          isAnimating = _this$state.isAnimating,
          isMounted = _this$state.isMounted;
      var _this$props = this.props,
          forceInitialAnimation = _this$props.forceInitialAnimation,
          isOpen = _this$props.isOpen,
          unmountChildren = _this$props.unmountChildren;
      var shouldMount = unmountChildren ? isOpen || isAnimating : true;
      var initiallyHidden = !isMounted && forceInitialAnimation && isOpen;
      return _react["default"].createElement(this.props.component, Object.assign({}, this.props.componentProps, {
        className: this.props.className,
        onTransitionEnd: this.onTransitionEnd,
        ref: function ref(el) {
          return _this3.wrapper = el;
        },
        style: _objectSpread({}, this.props.componentProps.style, {
          height: this.state.height,
          overflow: isAnimating || !isOpen || initiallyHidden ? "hidden" : null,
          visibility: !isAnimating && !isOpen || initiallyHidden ? "hidden" : null,
          transition: isAnimating || initiallyHidden ? "height ".concat(this.props.duration, "ms ").concat(this.props.easing) : null
        })
      }), shouldMount && this.props.children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var openDidChange = nextProps.isOpen !== prevState.isOpen;
      var forceAnimation = !prevState.isMounted && nextProps.forceInitialAnimation && nextProps.isOpen;
      return {
        isOpen: nextProps.isOpen,
        shouldAnimate: openDidChange || forceAnimation
      };
    }
  }]);

  return Collapse;
}(_react["default"].Component);

_defineProperty(Collapse, "defaultProps", {
  animateChildren: false,
  component: "div",
  componentProps: {},
  duration: 500,
  easing: "cubic-bezier(0.3,0,0,1)",
  forceInitialAnimation: false,
  isOpen: false,
  onMeasure: function onMeasure() {},
  unmountChildren: false
});

var _default = Collapse;
exports["default"] = _default;